import {css} from 'styled-components';

const styles = css`
width: 100%;
display: flex;
padding: 20px;
flex-direction: column;
gap: 10px;
 > .title {
  font-size: 1.5em;
  display: flex;
  padding-bottom: 10px;
 }`;

 export default styles;